<p-progressSpinner class="p-spinner" [hidden]="progressSpinner" [style]="{width: '50px', height: '50px'}"
  strokeWidth="8" fill="#EEEEEE" animationDuration=".5s"></p-progressSpinner>
<div id="cardDiv" *ngIf="ExecutionCard" class="card" style="clear: left;">

  <button style="float:right" id="graphButton" pButton [label]=otherGraph (click)="changeGtype()"> </button>
  <div class="margin graphContainer" style="width:60%;position:relative;margin:auto;">
    <div id="graphDiv">
      <p-toast position="top-right" key="tl"></p-toast>
      <p-chart #chart [type]=graphType [responsive]="true" [data]="data" (onDataSelect)="selectData($event)"
        [options]="chartOptions"></p-chart>
    </div>
  </div>
  <!-- Execution Details    -->
  <div class="container">
    <table class="mainTable">
      <thead>
        <tr>
          <th>Application:</th>
          <th>Location:</th>
          <th>Job name:</th>
          <th *ngIf="description !=null">Description:</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>{{this.application}}</td>
          <td>{{this.location}}</td>
          <td>{{this.jobName}}</td>
          <td *ngIf="description !=null">{{this.description}}</td>
        </tr>
      </tbody>      
    </table>
    <button class="btn showmore" (click)="showmore()"><i class={{cardIcon}}></i> Previous Executions</button>
    <button class="btn showmore" (click)="showmoreForecast()"><i class={{cardIconForecast}}></i> Forecast
      Executions</button>
    <!-- Previous Executions Table   -->
    <table class="tabla" [hidden]="tPrevious">

      <thead>
        <tr>
          <th>Date</th>
          <th>From</th>
          <th>To</th>
          <th>Status</th>
        </tr>
      </thead>

      <tbody>
        <tr *ngFor="let PreviousJobs of jobPrevious">
          <td data-label="Date">{{PreviousJobs.startTimestampUtc | date:'dd/MM/yyyy'}}</td>
          <td data-label="From">{{PreviousJobs.startTimestampUtc | date:'HH:mm:ss'}}</td>
          <td data-label="To">{{PreviousJobs.endTimestampUtc | date:'HH:mm:ss'}}</td>
          <td class="status" data-label="Status">
            <a [style.color]="statusHandler(PreviousJobs.status)">
              <a [ngClass]="statusIconHandler(PreviousJobs.status)"></a>
              {{PreviousJobs.status}}
            </a>
          </td>
        </tr>
      </tbody>

    </table>

    <!-- Forecast Table   -->
    <table class="tabla" [hidden]="tForecast">
      <p *ngIf="jobForecast.length==0"> No Forecast Jobs Found </p>
      <thead *ngIf="jobForecast.length>0">

        <tr>
          <th>Date</th>
          <th>From</th>
          <th>To</th>
          <th>Status</th>
        </tr>

      </thead>
      <tbody *ngIf="jobForecast.length>0">
        <tr *ngFor="let ForecastJobs of jobForecast">
          <td data-label="Date">{{ForecastJobs.startTimestampUtc | date:'dd/MM/yyyy'}}</td>
          <td data-label="From">{{ForecastJobs.startTimestampUtc | date:'HH:mm:ss'}}</td>
          <td data-label="To">{{ForecastJobs.endTimestampUtc | date:'HH:mm:ss'}}</td>
          <td class="status" data-label="Status"><a [style.color]="statusHandler(ForecastJobs.status)"><a
                [ngClass]="statusIconHandler(ForecastJobs.status)"></a>{{ForecastJobs.status}}</a></td>
        </tr>
      </tbody>
    </table>

  </div>


</div>